var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracking-tag",attrs:{"type":_vm.type}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.transformType)))])
}
var staticRenderFns = []

export { render, staticRenderFns }